// Reusable Card Component for this section
const ServiceCard = ({ title, desc, icon, color }) => (
  <div className="group bg-slate-800/50 backdrop-blur-md p-8 rounded-2xl border border-slate-700 hover:border-slate-500 transition-all duration-300 hover:-translate-y-2 hover:bg-slate-800 cursor-default">
    {/* Icon with Gradient Background */}
    <div
      className={`w-14 h-14 rounded-xl bg-gradient-to-br ${color} flex items-center justify-center text-2xl mb-6 shadow-lg group-hover:scale-110 transition-transform duration-300`}
    >
      {icon}
    </div>

    <h3 className="text-xl font-bold mb-3 text-white group-hover:text-transparent group-hover:bg-clip-text group-hover:bg-gradient-to-r group-hover:from-white group-hover:to-slate-300 transition-all">
      {title}
    </h3>
    <p className="text-slate-400 text-sm leading-relaxed">{desc}</p>
  </div>
);

const MediaAndPrintSection = () => {
  return (
    <section className="py-24 bg-slate-900 text-white relative overflow-hidden">
      {/* Decorative Background Pattern */}
      <div
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage: "radial-gradient(#6366f1 1px, transparent 1px)",
          backgroundSize: "40px 40px",
        }}
      ></div>

      <div className="container mx-auto px-6 max-w-screen-xl relative z-10">
        {/* --- Section Header --- */}
        <div className="text-center max-w-3xl mx-auto mb-20">
          <span className="inline-block py-1 px-3 rounded-full bg-indigo-500/20 border border-indigo-500/50 text-indigo-300 text-xs font-bold uppercase tracking-widest mb-4">
            Expand Your Reach
          </span>
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Beyond the Screen <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-400 to-cyan-400">
              & Print
            </span>
          </h2>
          <p className="text-lg text-slate-400 leading-relaxed">
            From digital banners to physical merchandise and high-end packaging,
            we cover every canvas your brand needs to shine on.
          </p>
        </div>

        {/* --- Services Grid (6 Items) --- */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {/* Service 1: Social Media */}
          <ServiceCard
            title="Social Media Graphics"
            desc="Eye-catching posts, stories, and banners tailored for Instagram, LinkedIn, and more."
            icon="📱"
            color="from-pink-500 to-rose-500"
          />

          {/* Service 2: Print Media */}
          <ServiceCard
            title="Print Media"
            desc="Professional brochures, flyers, catalogs, and magazine layouts with print-ready precision."
            icon="🖨️"
            color="from-blue-500 to-cyan-500"
          />

          {/* Service 3: Packaging */}
          <ServiceCard
            title="Product Packaging"
            desc="Unique box designs and labels that stand out on the shelf and tell your product's story."
            icon="📦"
            color="from-orange-500 to-amber-500"
          />

          {/* Service 4: Pitch Decks */}
          <ServiceCard
            title="Pitch Decks"
            desc="Compelling presentation designs (PowerPoint/Keynote) to help you win investors."
            icon="📊"
            color="from-green-500 to-emerald-500"
          />

          {/* Service 5: Merchandise */}
          <ServiceCard
            title="Custom Merchandise"
            desc="T-shirts, hoodies, mugs, and swag designs that your customers will love to wear."
            icon="🧢"
            color="from-purple-500 to-violet-500"
          />

          {/* Service 6: Illustration */}
          <ServiceCard
            title="Custom Illustrations"
            desc="Hand-drawn or digital artwork to add a unique, personal touch to your website or app."
            icon="🎨"
            color="from-red-500 to-orange-500"
          />
        </div>
      </div>
    </section>
  );
};

export default MediaAndPrintSection;
